import { httpClient } from '@bcba/client-auth';

const basePath = '/public/sign-up/admin-validation';

export const isAdminUserAvailable = async (
  email: string,
  fiscalId: string,
): Promise<{ emailIsAvailable: boolean; fiscalIdIsAvailable: boolean }> => {
  const { data } = await httpClient.get<{
    emailIsAvailable: boolean;
    fiscalIdIsAvailable: boolean;
  }>(`${basePath}`, {
    params: { email, fiscalId },
  });

  return data;
};
